/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * No claims discount.   (german: Schadensfreiheitsklasse)
 */
export const NcdClass = {
  Sf01: 'SF01',
  Sf02: 'SF02',
  Sf03: 'SF03',
  Sf04: 'SF04',
  Sf05: 'SF05',
  Sf06: 'SF06',
  Sf07: 'SF07',
  Sf08: 'SF08',
  Sf09: 'SF09',
  Sf10: 'SF10',
  Sf11: 'SF11',
  Sf12: 'SF12',
  Sf13: 'SF13',
  Sf14: 'SF14',
  Sf15: 'SF15',
  Sf16: 'SF16',
  Sf17: 'SF17',
  Sf18: 'SF18',
  Sf19: 'SF19',
  Sf20: 'SF20',
  Sf21: 'SF21',
  Sf22: 'SF22',
  Sf23: 'SF23',
  Sf24: 'SF24',
  Sf25: 'SF25',
  Sf26: 'SF26',
  Sf27: 'SF27',
  Sf28: 'SF28',
  Sf29: 'SF29',
  Sf30: 'SF30',
  Sf31: 'SF31',
  Sf32: 'SF32',
  Sf33: 'SF33',
  Sf34: 'SF34',
  Sf35: 'SF35',
  Sf36: 'SF36',
  Sf37: 'SF37',
  Sf38: 'SF38',
  Sf39: 'SF39',
  Sf40: 'SF40',
  Sf41: 'SF41',
  Sf42: 'SF42',
  Sf43: 'SF43',
  Sf44: 'SF44',
  Sf45: 'SF45',
  Sf46: 'SF46',
  Sf47: 'SF47',
  Sf48: 'SF48',
  Sf49: 'SF49',
  Sf50: 'SF50',
  Sf51: 'SF51',
  Sf52: 'SF52',
  Sf53: 'SF53',
  Sf54: 'SF54',
  Sf55: 'SF55',
  Sf56: 'SF56',
  Sf57: 'SF57',
  Sf58: 'SF58',
  Sf59: 'SF59',
  Sf60: 'SF60',
  Sf122: 'SF_1_2',
  SfS: 'SF_S',
  Sf0: 'SF_0',
  SfM: 'SF_M',
} as const;
export type NcdClass = (typeof NcdClass)[keyof typeof NcdClass];
